import { Link } from 'react-router-dom';
import MenuItemType from '@rootCommon/types/menu-item';
import { MouseEvent } from 'react';

type Props = {
  item: MenuItemType;
};

const MenuItem = ({ item }: Props): JSX.Element => {
  const handleClick = (): void => {
    !item.isDisabled && item.onClickItem && item.onClickItem();
  };

  const handleClickAnchor = (e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>): void => {
    if (item.isDisabled) {
      e.preventDefault();
    }
  };

  const Item = (
    <div
      className="user-auth__dropdown-item"
      style={{ width: '100%' }}
      onClick={handleClick}
      onKeyPress={handleClick}
      role="menuitem"
      tabIndex={-1}
    >
      <div className="user-auth__dropdown-ico">
        <img src={item.icon} alt={item.icon} />
      </div>
      <div className="user-auth__dropdown-text">{item.name}</div>
    </div>
  );

  if (item.path) {
    return (
      <Link style={{ width: '100%' }} to={item.path}>
        {Item}
      </Link>
    );
  }

  return item.href ? (<a href={item.href} onClick={handleClickAnchor}>{Item}</a>) : (Item);
};

export default MenuItem;
